import React from "react";
import {Field, FieldProps} from "formik";
import AutocompleteServer, {AdditionalParams, OptionData} from "./AutocompleteServer";
import {Grid, Typography} from "@mui/material";
import {PaginationResponse} from "../types/api";

interface AutocompleteFieldProps {
    name: string;
    fetchOptions: (query: string, page: number, size: number, additionalParams?: AdditionalParams
    ) => Promise<PaginationResponse<OptionData[]>>;
    label: string
    additionalParams?: AdditionalParams;
    disabled?: boolean;
}

const AutocompleteField: React.FC<AutocompleteFieldProps> = ({name, fetchOptions, label, additionalParams, disabled}) => (
    <Field name={name}>
        {({field, meta, form}: FieldProps) => (
            <Grid>
                <AutocompleteServer
                    fetchOptions={fetchOptions}
                    additionalParams={additionalParams}
                    value={field.value}
                    label={label}
                    size="small"
                    onSelect={(value: OptionData | null) => form.setFieldValue(name, value)}
                    onBlur={() => form.setFieldTouched(name, true)}
                    error={!!(meta.touched && meta.error)}
                    disabled={disabled}
                />

                {(meta.touched && meta.error) &&
                    <Typography
                        color="#d32f2f" fontSize="0.75rem"
                        mt="4px" mx="14px" mb="0"
                    >
                        {meta.error}
                    </Typography>
                }
            </Grid>
        )}
    </Field>
);

export default AutocompleteField;
